/**
 * API接口配置
 * 和服务端通讯的接口都要写在这里哦
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
  * @create 2018-03-15
 */

import axios from 'axios'
import qs from 'qs'
import conf from './../../config/base.js'
import { setToken, getToken, clog } from '@/common/js/common'

function fetch(baseURL = '/') {
  var instance = axios.create({
    baseURL,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8;'
    }
  })

  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      // POST传参序列化
      if (config.method === 'post') {
        config.data = qs.stringify(config.data)
      }
      // }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  // http response 拦截器
  instance.interceptors.response.use(
    response => {
      // 返回响应时做一些处理，我们这里直接返回
      return response
    },
    error => {
      // 当响应异常时做一些处理
      return Promise.reject(error)
    }
  )
  return instance;
}

/**
 * 销项服务API接口调用
 */
function salesApi() {
  return fetch(conf.api.SALES_API_ROOT);
}

/**
 * 进项服务API接口调用
 */
function purchaseApi() {
  return fetch(conf.api.PURCHASE_API_ROOT);
}

function getHttpIntegrate () {
  /**
   * http配置,调用集成接口
   */
  var instance = axios.create({
    baseURL: conf.api.api_owt,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8;'
    }
  })

  // http request 拦截器
  instance.interceptors.request.use(
    config => {
      // POST传参序列化
      if (config.method === 'post') {
        config.data = qs.stringify(config.data)
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  // http response 拦截器
  instance.interceptors.response.use(
    response => {
      // 返回响应时做一些处理，我们这里直接返回
      return response
    },
    error => {
      // 当响应异常时做一些处理
      return Promise.reject(error)
    }
  )
  return instance
}

export const api = {
  /*
   * 获取识别票据影像分页列表
   * @param  dataMap{
      documentType	文档类型
      invoiceDate	发票上传时间（yyyyMMdd）	是	String  服务器会按照月来查询
      verifyFlag	验真状态（-1-未验真，0-验真中，1-验真成功，2-验真失败）	否	String
      discrenFlag	识别状态（-1-未识别，0-识别中，1-识别完成）	否	String
      processFlag	报销状态（-1-未报销，0-报销中，1-报销完成）	否	String
      page	查询页数（默认1）	否	Number
      rows	查询行数（默认15）
    }
    @return
    {
     "status": 1,
      "msg": "查询成功",
      "result": {
          "totalPage": 2,
          "pageIndex": 1,
          "pageSize": 4,
          "totalRecord": 7,
          "list": []
      }
    }
   *
   */
  listInvoice (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('获取识别票据影像分页列表-请求参数：')
    clog(_params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.getInvoiceListByCollections&APIKey=' + getToken(),
      // 'http://10.50.0.165:8082/issp/ApiService?method=xforceplus.toc.getInvoiceListByCollections&APIKey=' + getToken(),
      _params
    )
  },
  /*
    * 创建发票影像文档
    * @param  dataMap{
       imageFile	picture文件转base64字符串	是	String
       pdfFile	PDF文件转base64字符串	是	String
       documentType	文档类型	是	String
       documentTypeName	文档类型名称	否	String
       extInfo	特殊文档类型中特殊字段	否	String
       remark	备注	否	String
       注:图片或PDF二者必传其一，否则报错
     }
     @return
    *
    */
  createInvoice (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('创建发票影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.imageUploadV3&APIKey=' + getToken(), _params)
  },
  /*
   * 创建发票影像文档  不上传图片   扫描二维码时候使用
   * @param  dataMap{
       invoiceCode	发票代码	是	String
       invoiceNo	发票号码	是	String
       paperDrewDate	开票日期（yyyyMMdd）	是	String
       checkCode	校验码（20位，需要后6位）	否	String
       amountWithoutTax	不含税金额
       documentType 文档类型
    }
    @return
   *
   */
  createInvoice2 (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('创建发票影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.invoiceAddByManual&APIKey=' + getToken(), _params)
  },

  /*
   * 创建发票影像文档  导入微信卡包 使用
   * @param
   * dataMap={
      "itemList": [
         {
              "card_id": "pjZ8Yt7KKEXWMpETmwG2ZZxX2m6E",
              "encrypt_code": "O/mPnGTpBu22a1szmK2 "
         },
         {
              "card_id": "pjZ8YtxSguaLUaaDqzeAf385soJM",
              "encrypt_code": "O/mPnGTpBu22a1szmK2ogz "
         }
     ]
  }
    @return
   *
   */
  createInvoice3 (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('创建发票影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.importWechatInvoice&APIKey=' + getToken(), _params)
  },

  /*
     * 创建发票影像文档
     * @param  dataMap{
        invoiceId  发票Id
      }
      @return
     *
     */
  oneInvoice (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('获取一个影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getInvoiceByIdV2&APIKey=' + getToken(), _params)
  },

  /*
   * 编辑发票影像文档   --增值税发票
   *
   * 专票、机动车发票不需要传校验码
   *
   * @param  dataMap{
                imageFile	picture文件转base64字符串	是	String
                pdfFile	PDF文件转base64字符串	是	String
                documentType	文档类型	是	String
                documentTypeName	文档类型名称	否	String
                extInfo	特殊文档类型中特殊字段	否	String
                remark	备注	否	String
                注:图片或PDF二者必传其一，否则报错
    }
    @return
   *
   */
  updateInvoice1 (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('创建发票影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.updateInvoiceMainInfo&APIKey=' + getToken(),
      _params
    )
  },
  /*
    * 编辑发票影像文档   --非增值税发票（飞机票、火车票、出租车票）
    * @param  dataMap{
    *         invoiceId	发票id	String	是
              documentType
              extInfo
                    火车票：[{‘key’:’train_no’,’value’:’’,’display_name’:’车次’},
                    {‘key’:’start_city’,’value’:’’,’display_name’:’出发地’},
                    {‘key’:’end_city’,’value’:’’,’display_name’:’到达地’}]

                    出租车票：[{‘key’:’start_time’,’value’:’’,’display_name’:’上车时间’},
                    {‘key’:’end_time’,’value’:’’,’display_name’:’下车时间’}]

                    飞机票：
                    [{‘key’:’ flight_no’,’value’:’’,’display_name’:’航班号’},
                    {‘key’:’start_city’,’value’:’’,’display_name’:’出发地’},
                    {‘key’:’end_city’,’value’:’’,’display_name’:’到达地’}]

                    其他：[{‘key’:’data’,’value’:’’,’display_name’:’信息’}]
     }
     @return
    *
    */
  updateInvoice2 (params) {
    // if (
    //   params.tInvoiceExtendObjStr != '' ||
    //   params.tInvoiceExtendObjStr != null ||
    //   params.tInvoiceExtendObjStr != undefined
    // ) {
    //   params.tInvoiceExtendObjStr = JSON.stringify(params.tInvoiceExtendObjStr);
    // }
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('创建发票影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.updateInvoiceMainInfo&APIKey=' + getToken(),
      _params
    )
  },
  /*
      * 编辑发票影像文档   --非增值税发票（除了飞机票、火车票、出租车票）
      * @param  dataMap{

         invoiceId	发票id	String	是
          invoiceCode	发票代码	String	否
          invoiceNo	发票号码	String	否
          //invoiceType	发票类型(c-普纸,s-专纸,ce-电票,v-机动车票,fj-附件)	String	否
          //invoiceFlag	发票状态(1-正常，2-作废)	String	否
          amountWithTax	含税金额	Number	否
          amountWithoutTax	不含税金额	Number	否
          taxAmount	税额	Number	否
          taxRate	税率	Number	否
          paperDrewDate	发票日期	String	否
          purchaserTaxNo	购方税号	String	否
          purchaserName	购方名称	String	否
          purchaserBankAccount	购方银行账号	String	否
          purchaserBankName	购方银行名称	String	否
          purchaserTel	购方电话	String	否
          purchaserAddress	购方地址	String	否
          sellerTaxNo	销方税号	String	否
          sellerName	销方名称	String	否
          sellerBankAccount	销方银行账号	String	否
          sellerBankName	销方银行名称	String	否
          sellerTel	销方电话	String	否
          sellerAddress	销方地址	String	否
          //machineCode	机器码	String	否
          checkCode	校验码	String	否
          //cashierName	收款人	String	否
          //checkerName	复核人	String	否
          //invoicerName	开票人	String	否
          remark	备注	String	否
          //ext1	扩展字段1-标签	String	否     id1,id2,id3
          //ext2	扩展字段2	String	否
          //ext3	扩展字段3	String	否
          documentType	文档类型	String	否
          documentTypeName	文档类型名称	String	否
          //extInfo	各文档类型的独有信息，JSON格式存储	String	否

       }
       @return
      *
      */
  updateInvoice3 (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('创建发票影像文档-请求参数：')
    clog(_params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.updateInvoiceMainInfo&APIKey=' + getToken(),
      _params
    )
  },

  /**
   * 个人备注update接口
   */
  updatePersonalRemark (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.updatePersonalRemark&APIKey=' + getToken(), _params)
  },
  /**
   * 二维码过期接口
   */
  invoiceMakeOverdue (orderId) {
    var _params = {
      dataMap: JSON.stringify({
        order: orderId
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.invoiceMakeOverdue&APIKey=' + getToken(), _params)
  },
  /**
   * 查询商户是否需要关注公众号
   */
  subscribeWx (groupFlag) {
    var _params = {
      dataMap: JSON.stringify({
        groupFlag: groupFlag
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.subscribeWx', _params)
  },
  /**
   * 获取公众号授权appid
   */
  gWx3rdAppId (groupFlag) {
    var _params = {
      dataMap: JSON.stringify({
        groupFlag: groupFlag
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.sys.gWx3rdAppId', _params)
  },
  /**
   * 商户微信获取授权页方式
   */
  getWxAuthUrlConf (groupFlag) {
    var _params = {
      dataMap: JSON.stringify({
        groupFlag: groupFlag
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getWxAuthUrlConf&APIKey=' + getToken(), _params)
  },
  /**
   * 获取商户开票信息配置
   */
  getPurchaserInfoConf (groupFlag) {
    var _params = {
      dataMap: JSON.stringify({
        groupFlag: groupFlag
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getPurchaserInfoConf&APIKey=' + getToken(), _params)
  },

  /*
   * 删除发票影像
   @param dataMap{
     invoiceId	抬头id	是	String
   }
   */
  deleteInvoice (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('删除发票-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.deleteInvoice&APIKey=' + getToken(), _params)
  },

  /**
   * 获取一个发票的验真结果
   @param dataMap{
     invoiceId	抬头id	是	Number
   }
   * */
  oneInvoiceCheckResult (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('获取一个发票的验真结果-请求参数：')
    clog(_params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.queryVerifyInvoiceById&APIKey=' + getToken(),
      _params
    )
  },

  /*
     * 获取发票影像的标签列表
     * @param  dataMap{
        invoiceId  发票Id
      }
      @return
     *
     */
  listTagByInvoice (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('获取一个影像文档的标签列表-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getLabels&APIKey=' + getToken(), _params)
  },

  /*
     * 新增标签
     * @param  dataMap{
        labelName  标签名
      }
      @return
     *
     */
  createTag (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('新增标签-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.addLabel&APIKey=' + getToken(), _params)
  },

  /*
     * 编辑标签
     * @param  dataMap{
        labelId  标签Id
        labelName  标签名
      }
      @return
     *
     */
  updateTag (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('编辑标签-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.updateLabel&APIKey=' + getToken(), _params)
  },

  /*
     * 删除标签
     @param  dataMap{
        labelId  标签Id
      }
      @return
     *
     */
  deleteTag (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('删除标签-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.deleteLabel&APIKey=' + getToken(), _params)
  },

  /*
   * 移除或添加一个发票的标签
  @ param  dataMap{
        labelId  标签Id
        invoiceId 发票Id
        status  0 移除   1增加
      }
      @return
     *
     */
  updateInvoiceTag (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('移除或添加一个发票的标签-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.updateInvoiceLabel&APIKey=' + getToken(), _params)
  },

  /*
     * 批量添加业务标签 （德邦BP报销）
     * @param  dataMap{
     *  invoices 发票id集合
        label  标签名
      }
      @return
     *
     */
  labelBatchAdd (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.labelBatchAdd&APIKey=' + getToken(), _params)
  },
  /*
     * 批量删除发票（目前只有德邦用到）
     * @param  dataMap{
        invoices  发票id集合
      }
      @return
     *
     */
  deleteInvoiceBatch (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.deleteInvoiceBatch&APIKey=' + getToken(), _params)
  },
  /*
     * BP发票提交（目前只有德邦用到）
     * @param  dataMap{
        invoices  发票id集合
      }
      @return
     *
     */
  invoiceBatchCommit (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.invoiceBatchCommit&APIKey=' + getToken(), _params)
  },

  /*
   * 单点登录获取数据
   */
  switchUserToken (params) {
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.SwitchUserToken&APIKey=' + conf.api.api_key, params)
  },
  /*
   * 请求发票抬头列表
   @param dataMap{ }
   */
  listInvoiceTitle (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('请求发票抬头列表-请求参数：')
    clog(_params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.getTitleListByCreateId&APIKey=' + getToken(),
      _params
    )
  },
  /**
   * 新增发票抬头
   @param dataMap{
    name	抬头名称	是	String
    taxerId	税号(15-20位数字字母组合，不能全为0)	否	String
    bankName	银行名称	否	String
    bankAccount	银行账号	否	String
    companyPhone	公司电话(用户手机)	否	String
    conpanyAddr	公司地址(用户地址)	否	String
    email	用户邮箱	否	String
    isSpecialInvoice	是否专票抬头(1-是，0-不是)	否	String
    isVerified	是否验真抬头(1-是，0-不是)	否	String
    isDefault	是否默认抬头(1-是，0-不是)
   }
   *  */
  createInvoiceTitle (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('新增发票抬头-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.insertTitle&APIKey=' + getToken(), _params)
  },
  /**
   * 上传发票抬头
   @param dataMap{
    groupFlag 分组代码
    storeCode: 门店号
    titleId 抬头id
   }
   *  */
  insertTitleAndGroupFlag (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('新增发票抬头-请求参数：')
    clog(_params)
    return salesApi().post(
      '/issp/ApiService?method=xforceplus.toc.insertTitleAndGroupFlag&APIKey=' + getToken(),
      _params
    )
  },
  /**
   * 获取一个发票抬头
   @param dataMap{
     id	抬头id	是	Number
   }
   * */
  oneInvoiceTitle (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('获取一个发票抬头-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getTitleById&APIKey=' + getToken(), _params)
  },

  /*
   * 更新发票抬头
   @param dataMap{
     id  抬头Id
    name	抬头名称	是	String
    taxerId	税号(15-20位数字字母组合，不能全为0)	否	String
    bankName	银行名称	否	String
    bankAccount	银行账号	否	String
    companyPhone	公司电话(用户手机)	否	String
    conpanyAddr	公司地址(用户地址)	否	String
    email	用户邮箱	否	String
    isSpecialInvoice	是否专票抬头(1-是，0-不是)	否	String
    isVerified	是否验真抬头(1-是，0-不是)	否	String
    isDefault	是否默认抬头(1-是，0-不是)
   }
   *  */
  updateInvoiceTitle (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('编辑发票抬头-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.updateTitle&APIKey=' + getToken(), _params)
  },
  /*
   * 删除发票抬头
   @param dataMap{
     id	抬头id	是	Number
   }
   */
  deleteInvoiceTitle (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    clog('删除发票抬头-请求参数：')
    clog(_params)
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.delete&APIKey=' + getToken(), _params)
  },
  testDemo (ddd) {
    alert(ddd)
  },
  testDemo2 () {
    return axios.get('https://www.easy-mock.com/mock/5a4896ba62de717d44f2406e/api/v1/product/recent')
  },
  /**
   * 获取二维码
   */
  orderQrcode (params) {
    return salesApi().post('/issp/qrcode/order/cpy.page', params)
  },
  /**
   * 获取公众号二维码
   */
  orderQrcodeWithOutSpy (params) {
    return salesApi().post('/issp/qrcode/group/subscribe.page', params)
  },
  /**
   * 加解密接口
   */
  hexEncryptOrDecrypt (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post(
      '/issp/ApiService?method=xforceplus.toc.hexEncryptOrDecrypt&APIKey=' + conf.api.api_key,
      params
    )
  },
  /**
   * 获取cmsUrl
   * @param {*} params
   */
  getCmsToken(params){
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getCmsToken&APIKey=' + getToken(), params)
  },
  /**
   * 获取用户抬头列表接口
   */
  getUserTitleList (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.queryByCreateId&APIKey=' + getToken(), params)
  },
  /**
   * 新增抬头接口
   */
  insertTitle (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.insert&APIKey=' + getToken(), params)
  },
  /**
   * 开票接口
   */
  invoice (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.invInsert&APIKey=' + getToken(), params)
  },
  /**
   * 通过微信code获取openid接口
   */
  subscribeUserInfo (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.sys.subscribeUserInfo', params)
  },
  /**
   * redis存储接口
   */
  redisInOut (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.redisInOut&APIKey=' + conf.api.api_key, params)
  },
  /**
   * 查询订单接口
   */
  queryOrderByUniCode (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.queryOrderByUniCode&APIKey=' + getToken(), params)
  },
  /**
   *判断用户是否绑定手机号
   */
  ifBindMobilePhone () {
    var params = {}
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.queryPhone&APIKey=' + getToken(), params)
  },
  /**
   *发送手机验证码  获取验证码  绑定手机号使用
   @param mobilePhone  手机号
   */
  getValidCodeForBindMobile (mobilePhone) {
    var params = {
      dataMap: JSON.stringify({
        mobilePhone: mobilePhone
      })
    }
    clog('获取绑定手机号验证码-请求参数：')
    clog(params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.getValidCodeForBindMobile&APIKey=' + getToken(),
      params
    )
  },
  /**
   *发送邮箱验证码  获取验证码  绑定邮箱使用
   @param mobilePhone  手机号
   */
  sendEmailCode (email) {
    var params = {
      dataMap: JSON.stringify({
        email: email
      })
    }
    clog('获取绑定手机号验证码-请求参数：')
    clog(params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.sendEmailCheckCode&APIKey=' + getToken(),
      params
    )
  },
  /**
   *校验验证码  校验后  就绑定手机了
   @param validCode  验证码
   @param mobilePhone  手机号
   */
  bindMobilePhone (validCode, mobilePhone) {
    var params = {
      dataMap: JSON.stringify({
        code: validCode,
        mobilePhone: mobilePhone
      })
    }
    clog('绑定手机号-请求参数：')
    clog(params)

    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.bindMobilePhone&APIKey=' + getToken(), params)
  },

  /**
   *发送手机验证码  获取验证码  解除绑定手机号使用
   @param mobilePhone  手机号
   */
  getValidCodeForUnBindMobile (mobilePhone) {
    var params = {
      dataMap: JSON.stringify({
        mobilePhone: mobilePhone
      })
    }
    clog('获取解除绑定手机号验证码-请求参数：')
    clog(params)
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.getValidCodeForUnBindMobile&APIKey=' + getToken(),
      params
    )
  },
  /**
   *校验验证码  校验后  就解除绑定手机了
   @param validCode  验证码
   @param mobilePhone  手机号
   */
  unBindMobilePhone (unBindType) {
    var params = {
      dataMap: JSON.stringify({
        unBindType: unBindType
      })
    }
    clog('解除绑定手机号-请求参数：')
    clog(params)

    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.unbindingMobileAndEmail&APIKey=' + getToken(), params)
  },

  /**
   *获取权限
   @param type  0 手机 1 邮箱
   */
  bindAccount (type) {
    var params = {
      dataMap: JSON.stringify({
        type: type
      })
    }
    clog('解除绑定手机号-请求参数：')
    clog(params)

    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.bindAccount&APIKey=' + getToken(), params)
  },


  /**
   *申请授权
   @param
   */
  bindApply () {
    var params = {
    }
    clog('解除绑定手机号-请求参数：')
    clog(params)

    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.bindApply&APIKey=' + getToken(), params)
  },

  /**
   *获取集团列表
   @param
   */
  queryTenantList (keyword) {
    var params = {
      dataMap: JSON.stringify({
        keyword: keyword,
        page: 1,
        rows: 10
      })
    }
    clog('解除绑定手机号-请求参数：')
    clog(params)

    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.queryTenantList&APIKey=' + getToken(), params)
  },

  /**
   * 获取微信jsapi配置
   */
  getJsapiSign () {
    // 生成签名的url(使用jssdk的页面地址，这个页面地址可以在浏览器访问)，包含“？”号后面的所有参数，不包含“#”号后面的值
    let url = location.href.split('#')[0]
    var params = {
      dataMap: JSON.stringify({
        url: url
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getJsapiSign&APIKey=' + getToken(), params)
  },

  /**
   * 获取飞书jsapi配置
   */
  getFeishuJsapiSign () {
    // 生成签名的url(使用jssdk的页面地址，这个页面地址可以在浏览器访问)，包含“？”号后面的所有参数，不包含“#”号后面的值
    let url = location.href.split('#')[0]
    var params = {
      dataMap: JSON.stringify({
        url: url
      })
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getFeishuApiSign&APIKey=' + getToken(), params)
  },

  /**
   *抬头联想
   */
  getTitleNameFrom16 (titleName) {
    var params = {
      dataMap: JSON.stringify({
        name: titleName
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getTitleNameFrom16&APIKey=' + getToken(), params)
  },
  /**
   *用户获取token
   */
  queryTokenByOtId (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.sys.qToken', params)
  },

  /**
   *抬头联想id获取详细信息
   */
  getTitleInfoByIdFrom16 (titleId) {
    var params = {
      dataMap: JSON.stringify({
        id: titleId
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getTitleInfoByIdFrom16&APIKey=' + getToken(), params)
  },
  /**
   * Walmart电子专票校验白名单
   */
   isBusinessLicense (groupFlag, storeCode, taxNo, taxName) {
    var params = {
      dataMap: JSON.stringify({
        groupFlag: groupFlag,
        storeCode: storeCode,
        taxNo: taxNo,
        taxName: taxName
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.isBusinessLicense&APIKey=' + getToken(), params)
  },
  /**
   *用户更新Email 更新
   */
  updateUserEmail (email,needUpdateEmailWhiteList) {
    var params = {
      dataMap: JSON.stringify({
        email,needUpdateEmailWhiteList
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.userUpdate&APIKey=' + getToken(), params)
  },
  /**
   *用户更新Email 更新
   */
  validateEmail (email) {
    var params = {
      dataMap: JSON.stringify({
        email: email
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.validateEmail&APIKey=' + getToken(), params)
  },
  /**
   *用户更新Email 更新
   */
  bindingEmail (email, code) {
    var params = {
      dataMap: JSON.stringify({
        email: email,
        code: code
      })
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.bindingEmail&APIKey=' + getToken(), params)
  },
  /**
   *获取用户信息
   */
  getUserInfo () {
    var params = {}
    var token =
      'YoO45SINRHhO8%2FBU%2BLGd34%2FmlEC1vMuezNP%2BdZv%2FubnU6LAYQF%2Fo5hWVZk6tDbK22jYaDccEwjVU%0Av%2F9ZhwDknw%3D%3D'
    // return getHttp2().post('/issp/ApiService?method=xforceplus.toc.getUserInfo&APIKey=' + token, params);
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getUserInfo&APIKey=' + getToken(), params)
  },

  /**
   *获取用户email
   */
  getUserEmail () {
    var params = {}
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.queryEmail&APIKey=' + getToken(), params)
  },
  /**
   *获取发票详情
   */
  getInvoiceById (params) {
    var params = {
      dataMap: JSON.stringify(params)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getInvByGroupInv&APIKey=' + getToken(), params)
  },
  getInvoiceByIdDeprecated (params) {
    var params = {
      dataMap: JSON.stringify(params)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.invoiceQueryById&APIKey=' + getToken(), params)
  },
  /**
   *邮件发送
   */
  sendInvoiceEmail (invoiceId, email) {
    var params = {
      dataMap: JSON.stringify({
        ids: [invoiceId],
        emailAddrs: email
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.invoiceEmails&APIKey=' + getToken(), params)
  },
  /**
   *微信确认登录
   */
  userLoginByQrcode (radomId) {
    var params = {
      dataMap: JSON.stringify({
        rid: radomId
      })
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.userLoginByQrcode&APIKey=' + getToken(), params)
  },
  /**
   *图片上传
   *@param base64Image  base64图片或pdf
   *@param discernFlag  表示是否可识别验真的发票，目前1是增值税发票可识别验真，0是其他票据
   */
  imageUploadV3 (base64Image, isDiscern) {
    var params = {
      dataMap: JSON.stringify({
        imageFile: base64Image,
        discernFlag: isDiscern
      })
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.imageUploadV3&APIKey=' + getToken(), params)
  },
  /**
   *微信jsapi接口获取图片上传
   *@param mediaId  微信上传图片后返回Id
   *@param discernFlag  表示是否可识别验真的发票，目前1是增值税发票可识别验真，0是其他票据
   */
  imageUploadForWechat (mediaIds, isDiscern) {
    var params = {
      dataMap: JSON.stringify({
        mediaIds: mediaIds,
        discernFlag: isDiscern
      })
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.imageUploadForWechat&APIKey=' + getToken(), params)
  },
  /**
   *微信用户获取token
   */
  queryTokenByCode (object) {
    // var params = {
    //   dataMap: JSON.stringify(object)
    // };
    var params = object
    return salesApi().post('/issp/ApiService?method=xforceplus.sys.gtoken', params)
  },
  /**
   *用户获取钉钉token   找后台要一个获取钉钉userid接口的的域名或者IP地址
   */
  // queryTokenByDing(object) {
  //   var params = object;
  //   return getHttp().post('/iop/dingTalkSelf/getDingUserID', params);
  // },
  /**
   *获取本地json文件信息
   */
  getStoreName (merchant) {
    // var params = {
    //   dataMap: JSON.stringify(object)
    // };
    var url = '/xforce/static/merch/' + merchant + '/branch.js'
    return axios.get(url)
  },
  /**
   *获取订单开票信息
   */
  getInvoiceByOrderId (orderId, orderNo, groupFlag) {
    var params = {
      dataMap: JSON.stringify({
        orderId: orderId,
        orderNo: orderNo,
        groupFlag: groupFlag,
      })
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getInvoiceByOrderId&APIKey=' + getToken(), params)
  },
  /**
   *绑定所属集团和个人工号
   @param companyName  集团名称
   @param otId  手机号
   */
  bindCompany (companyName, otId,code) {
    var params = {
      dataMap: JSON.stringify({
        companyName: companyName,
        otId: otId,
        code:code
      })
    }
    clog('绑定集团-请求参数：')
    clog(params)

    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.bindCompany&APIKey=' + getToken(), params)
  },
  /**
   * 加解密接口
   */
  scanNotify (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.scanNotify&APIKey=' + conf.api.api_key, params)
  },
  /**
   * 获取分组门店信息接口
   */
  getStoreConfig (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getStoreConfig&APIKey=' + conf.api.api_key, params)
  },
  /**
   * 获取发票详情 通过集成接口
   */
  getInvoiceDetail (params) {
    return getHttpIntegrate().post('/api/h5/getInvoiceDetail', params)
  },
  /**
   * 获取发票占用
   */
  getInvoiceOccupy (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getInvoiceOccupyUserInfo&APIKey=' + getToken(), params)
  },
  /**
   * 获取发票列表 通过集成接口
   */
  getInvoiceList (params) {
    return getHttpIntegrate().post('/api/h5/getInvoiceList', params)
  },
  /**
   * 获取MI账号
   */
  queryMIAccount (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.queryMIAccount&APIKey=' + conf.api.api_key, params)
  },
  /**
   * 销项发票列表
   */
  sellerInvoiceList (params) {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.sellerInvoiceList&APIKey=' + getToken(), params)
  },

  /**
   * 机器人打印发票列表
   */
  queryPrintInvoiceList (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.getPrintInvoiceList&APIKey=' + getToken(), params)
  },
  /**
   * 拉取微信发票
   */
  pullCardInvoices (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.pullCardInvoices&APIKey=' + getToken(), params)
  },
  /**
   * 打印发票列表
   */
  printInvoices (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.printInvoices&APIKey=' + getToken(), params)
  },
  /**
   * 删除发票列表
   */
  deleteInvoices (object) {
    var params = {
      dataMap: JSON.stringify(object)
    }
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.deletePrintInvoices&APIKey=' + getToken(), params)
  },
  /**
   * 城市列表
   */
  citys () {
    return salesApi().post('/issp/ApiService?method=xforceplus.toc.citys&APIKey=' + conf.api.api_key)
  },
  /**
   * 单票列表
   */
  singleInvoiceList (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.getAllInvoiceListByCollections&APIKey=' + getToken(),
      // 'http://10.50.0.165:8082/issp/ApiService?method=xforceplus.toc.getInvoiceListByCollections&APIKey=' + getToken(),
      _params
    )
  },
  /**
   *获取发票总计金额
   */
  getAllTotalInfoByCollections (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post('/issp/ApiService?method=xforceplus.toc.getAllTotalInfoByCollections&APIKey=' + getToken(), _params)
  },
  /**
   * 重新校验
   */
  recheckInvoiceException (params) {
    var _params = {
      dataMap: JSON.stringify(params)
    }
    return purchaseApi().post(
      '/issp/ApiService?method=xforceplus.toc.recheckInvoiceException&APIKey=' + getToken(),
      // 'http://10.50.0.165:8082/issp/ApiService?method=xforceplus.toc.getInvoiceListByCollections&APIKey=' + getToken(),
      _params
    )
  },
  getCmsUrl (userId) {
    return purchaseApi().get(
      '/ares/cmsRedirectUrl?userId=' + userId,
      // 'http://10.50.0.165:8082/issp/ApiService?method=xforceplus.toc.getInvoiceListByCollections&APIKey=' + getToken(),
    )
  },
  packageInvoice (body, src) {
    // alert('准备调用' + body + src + typeof body)
    // return axios({
    //   url: `/issp/third/accept-invoice?otId=${localStorage.getItem('otId')}&groupFlag=${localStorage.getItem('source')}&source=${src}`,
    //   method: 'POST',
    //   body: {
    //     data: body
    //   }
    // })
    return purchaseApi().post(`/issp/third/accept-invoice?otId=${localStorage.getItem('otId')}&groupFlag=${localStorage.getItem('source')}&source=${src}`, {
      dataMap: JSON.stringify(body)
    })
  },
  searchTenantName (tenantName) {
    return purchaseApi().get(`/issp/ApiService?method=xforceplus.toc.searchTenantName&APIKey=${getToken()}&tenantName=${encodeURIComponent(tenantName)}`)
  },

  /*
  * 根据url获取文件
  * @param  dataMap{
     imageUrl	图片url	是	String
   }
   @return
  *
  */
  imageUploadByUrl ({imageUrl}) {
    clog('图片上传-请求参数：')
    return purchaseApi().get(`/download/getUrlBytes?imageUrl=${escape(imageUrl)}`,
    )
  },

  /*
  * 获取滴滴和支付宝卡包授权状态
  * @param  dataMap{
     imageUrl	图片url	是	String
   }
   @return
  *
  */
  getAuthStatus() {
    clog('获取滴滴和支付宝卡包授权状态')
    return purchaseApi().get(`/issp/ApiService?method=xforceplus.toc.getAuthStatus&APIKey=${getToken()}`)
  },

  /*
    * 取消支付宝卡包授权
    * @param  dataMap{
       imageUrl	图片url	是	String
     }
     @return
    *
    */
  cancelAliAuth() {
    clog('取消支付宝卡包授权')
    return purchaseApi().get(`/issp/ApiService?method=xforceplus.toc.aliUnAuth&APIKey=${getToken()}`)
  },
}

// 对 api 重新封装成一个plugin ,方便 Vue.use(xxxx)
// 调用的时候 用 this.$webapi.deleteInvoiceTitle(....)
export default {
  install: function (Vue, Option) {
    Object.defineProperty(Vue.prototype, '$webapi', {
      value: api
    })
  }
}
